const QrIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 3C2 2.44772 2.44772 2 3 2H8C8.55228 2 9 2.44772 9 3V8C9 8.55228 8.55228 9 8 9H3C2.44772 9 2 8.55228 2 8V3ZM4 4V7H7V4H4ZM15 3C15 2.44772 15.4477 2 16 2H21C21.5523 2 22 2.44772 22 3V8C22 8.55228 21.5523 9 21 9H16C15.4477 9 15 8.55228 15 8V3ZM17 4V7H20V4H17ZM12 3C12.5523 3 13 3.44772 13 4V5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5V4C11 3.44772 11.4477 3 12 3ZM12 7.5C12.5523 7.5 13 7.94772 13 8.5V11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H13V15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0523 11 15.5V13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H11V8.5C11 7.94772 11.4477 7.5 12 7.5ZM18 12C18 11.4477 18.4477 11 19 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H19C18.4477 13 18 12.5523 18 12ZM2 16C2 15.4477 2.44772 15 3 15H8C8.55228 15 9 15.4477 9 16V21C9 21.5523 8.55228 22 8 22H3C2.44772 22 2 21.5523 2 21V16ZM4 17V20H7V17H4ZM15 16C15 15.4477 15.4477 15 16 15H21C21.5523 15 22 15.4477 22 16V21C22 21.5523 21.5523 22 21 22H16C15.4477 22 15 21.5523 15 21V16ZM17 17V20H20V17H17ZM12 17.5C12.5523 17.5 13 17.9477 13 18.5V19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5V18.5C11 17.9477 11.4477 17.5 12 17.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default QrIcon;
